import React from 'react';
import { useAuth, TenantPlan } from '../context/AuthContext';
import { Clock, AlertTriangle, CheckCircle, XCircle } from 'lucide-react';

const TrialBanner = () => {
  const { tenant, trialStatus, isDemo, isTrialExpired, isInTrial, daysRemaining } = useAuth();

  // Don't show for demo or active accounts
  if (isDemo || trialStatus?.status === TenantPlan.ACTIVE) {
    return null;
  }

  // Trial active - show subtle badge
  if (isInTrial && daysRemaining > 0) {
    return (
      <div 
        className="bg-blue-50 border-b border-blue-100 px-4 py-2 flex items-center justify-between text-sm"
        data-testid="trial-banner"
      >
        <div className="flex items-center gap-2 text-blue-700">
          <Clock className="w-4 h-4" />
          <span>
            Prueba gratuita: <strong>{daysRemaining} {daysRemaining === 1 ? 'día' : 'días'}</strong> restantes
          </span>
        </div>
        <a 
          href="/activar" 
          className="text-blue-700 hover:text-blue-900 font-medium hover:underline"
        >
          Activar ahora →
        </a>
      </div>
    );
  }

  // Trial expired - show warning
  if (isTrialExpired) {
    const graceDays = trialStatus?.grace_days_remaining || 0;
    
    return (
      <div 
        className="bg-amber-50 border-b border-amber-200 px-4 py-3 flex items-center justify-between text-sm"
        data-testid="trial-expired-banner"
      >
        <div className="flex items-center gap-2 text-amber-800">
          <AlertTriangle className="w-4 h-4" />
          <span>
            Tu periodo de prueba ha finalizado. 
            {graceDays > 0 && ` Tienes ${graceDays} días para activar sin perder datos.`}
          </span>
        </div>
        <div className="flex items-center gap-4">
          <a 
            href="/activar" 
            className="px-4 py-1.5 bg-orange-500 text-white rounded-lg hover:bg-orange-600 font-medium text-sm"
          >
            Activar MANDO
          </a>
          <a 
            href="mailto:soporte@leapifyes.com" 
            className="text-amber-700 hover:text-amber-900 text-sm hover:underline"
          >
            Hablar con un experto
          </a>
        </div>
      </div>
    );
  }

  // Blocked - show error
  if (trialStatus?.status === TenantPlan.BLOCKED) {
    return (
      <div 
        className="bg-red-50 border-b border-red-200 px-4 py-3 flex items-center justify-center text-sm"
        data-testid="blocked-banner"
      >
        <div className="flex items-center gap-2 text-red-800">
          <XCircle className="w-4 h-4" />
          <span>
            Cuenta bloqueada. {trialStatus?.blocked_reason || 'Contacta con soporte.'}
          </span>
          <a 
            href="mailto:soporte@leapifyes.com" 
            className="ml-4 text-red-700 hover:text-red-900 font-medium hover:underline"
          >
            Contactar soporte →
          </a>
        </div>
      </div>
    );
  }

  return null;
};

export default TrialBanner;
